<template>
    <div>
      <client-form ref="clientFormModal"></client-form>
      <b-modal id="trademarkOwnerFormModal" centered size="lg" no-close-on-backdrop ref="trademarkOwnerFormModal" :title=" $t('trademarkOwner.info')"
        :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
      <validation-observer ref="infoRules" tag="form">
        <b-row>
          <b-col>
            <b-form>
              <validation-provider :name=" $t('trademarkOwner.name')" #default="{ errors }" rules="required">
                <b-form-group :label="$t('trademarkOwner.name')" label-for="trademarkOwner" :state="errors.length > 0 ? false:null">
                  <b-input-group class="d-flex align-items-center">
                    <b-form-group label-for="trademark-owner-name-input" class="flex-grow-1 mb-0">
                      <v-select id="trademarkOwner" v-model="trademarkOwnerSelect" :options="trademarkOwnerOption" label="name" size="sm"  @search="onSearch"></v-select>
                      
                      <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                        {{ errors[0] }}
                      </b-form-invalid-feedback> 
                    </b-form-group>
                    <b-input-group-append>
                      <b-dropdown style="width: 3em; height: 2.5em" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                        <template #button-content>
                          <feather-icon icon="MenuIcon" size="10" class="align-middle" />
                        </template>
                        <b-dropdown-item @click="getOwnerInfo(0)">
                          <span>{{$t('others.add_client')}}</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-form>
          </b-col>
        </b-row>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>

  export default {
    props: {
      trademarkId: Number, 
      getTrademarkOwnerList: {type: Function},
      getTrademarkList: {type: Function},
    },
    data() {
      return {
        id: 0,
        trademarkOwnerSelect: '',
        trademarkOwnerOption: [],
      }
    },
    methods: {
      showInfo(){
        this.$refs['trademarkOwnerFormModal'].show()
      },
      onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search(loading, search, vm) {
      if(search.length > 2){
        const data = {name: search}
        const controller = { name: 'Client', actionName:'GetOwnerClientByName' }
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          this.trademarkOwnerOption = response.data.clientList
          loading(false)
        })
      }
    },
    async getOwnerInfo(clientId) {
      this.$refs.clientFormModal.showInfo(clientId)
    }, 
      addOrUpdate() {
        const data = {id: this.id, trademarkId: this.trademarkId, clientId: this.trademarkOwnerSelect.id}
        const controller = { name: 'TrademarkOwner' }
        const payload = { data: data, controller: controller }
        this.$refs.infoRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('trademarkOwnerFormModal')
                    this.getTrademarkOwnerList()
                    this.getTrademarkList()
                    this.trademarkOwnerSelect = ''
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
              }
            })
          }
      },
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  [dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}
.agentInput {
  max-width: 87em !important;
  width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
  white-space: pre-wrap !important;
}
  </style>
  